import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import * as Reporting from 'src/services/reporting';
import VersionUpdateBanner from 'src/shared/pwa/VersionUpdateBanner';

import { ButtonV2, Typography } from 'src/shared/components/ui';

const ErrorFallback = () => (
  <div className="flex flex-col items-center justify-center h-full min-h-dvh gap-4">
    <Typography variant="h1" weight="bold">
      Oops! Something went wrong.
    </Typography>
    <ButtonV2 onPress={() => (window.location.href = '/')}>
      Go back home
    </ButtonV2>
  </div>
);

const ErrorBoundaryLayout = () => (
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onError={(error) => {
      Reporting.captureException({ error });
    }}
  >
    <VersionUpdateBanner />
    <Outlet />
  </ErrorBoundary>
);

export default ErrorBoundaryLayout;
